import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import ComponentMetaData from '../component-meta-data'
import DataLayer from '../data-layer'
import canonicalLink from '../../helpers/canonical-link'
import { useGetHrefContext } from '../../context'

const isValidMeta = meta =>
  meta.canonical ||
  meta.title ||
  meta.description ||
  meta.schema ||
  meta.openGraphData

const TitleAndDescription = ({
  getMetaData,
  canonicalizeUrl,
  ...inputProps
}) => {
  const getUrl = useGetHrefContext()
  const canonicalize = canonicalizeUrl || canonicalLink.canonical
  const defaultCanonical = canonicalize(getUrl())
  const meta = getMetaData({
    ...inputProps,
    canonical: defaultCanonical,
  })
  const canonicalConfirm = meta.canonical || defaultCanonical
  return isValidMeta(meta) ? (
    <Fragment>
      <Helmet>
        {meta.title && <title>{meta.title}</title>}
        {meta.description && (
          <meta name="description" content={meta.description} />
        )}
        {canonicalConfirm && <link rel="canonical" href={canonicalConfirm} />}
      </Helmet>
      <ComponentMetaData
        data={{
          structuredData: meta.schema,
          openGraphData: meta.openGraphData,
        }}
      />
      <DataLayer {...meta.datalayer} />
    </Fragment>
  ) : null
}

TitleAndDescription.propTypes = {
  getMetaData: PropTypes.func,
  canonicalizeUrl: PropTypes.func,
  canonical: PropTypes.string,
}

TitleAndDescription.defaultProps = {
  getMetaData: () => ({}),
}

export default TitleAndDescription
